// Map framing only: extents of the approved resolution-9 overlapping cells.
// Property membership is calculated and filtered on the API. [west, south, east, north]
export const KINGSTON_POSTAL_BOUNDS = Object.freeze({
  "downtown-kingston": [
    -76.818738,
    17.960674,
    -76.768164,
    17.988055
  ],
  "kingston-1": [
    -76.848689,
    17.930009,
    -76.836165,
    17.941782
  ],
  "kingston-2": [
    -76.775837,
    17.963993,
    -76.741577,
    17.990416
  ],
  "kingston-3": [
    -76.779794,
    17.977702,
    -76.758681,
    18.004344
  ],
  "kingston-4": [
    -76.791258,
    17.972924,
    -76.778445,
    17.988055
  ],
  "kingston-5": [
    -76.806088,
    17.981802,
    -76.766391,
    18.01372
  ],
  "kingston-6": [
    -76.783957,
    17.998822,
    -76.732218,
    18.052782
  ],
  "kingston-7": [
    -76.754801,
    17.981241,
    -76.73121,
    18.017256
  ],
  "kingston-8": [
    -76.815091,
    18.023581,
    -76.761073,
    18.069612
  ],
  "kingston-9": [
    -76.845144,
    18.053325,
    -76.762372,
    18.124101
  ],
  "kingston-10": [
    -76.822896,
    17.998145,
    -76.770053,
    18.035835
  ],
  "kingston-11": [
    -76.845235,
    17.985949,
    -76.808103,
    18.027468
  ],
  "kingston-12": [
    -76.809843,
    17.978481,
    -76.789317,
    17.993838
  ],
  "kingston-13": [
    -76.831887,
    17.966961,
    -76.797028,
    18.00681
  ],
  "kingston-14": [
    -76.807864,
    17.968144,
    -76.793071,
    17.983277
  ],
  "kingston-17": [
    -76.730075,
    17.943985,
    -76.697,
    17.96345
  ],
  "kingston-19": [
    -76.836835,
    18.030818,
    -76.799117,
    18.061982
  ],
  "kingston-20": [
    -76.862337,
    18.014304,
    -76.803758,
    18.040205
  ]
});
